<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="select" label="所属模块" name="classify" options="CLASSIFY_SHARE"></c-form-item>
                    <c-form-item type="input" label="发布用户" name="nick_name"></c-form-item>
                    <c-form-item type="input" label="标题" name="title"></c-form-item>
                    <c-form-item type="select" label="是否推荐" name="is_recommend" :options="recommendState"></c-form-item>
                    <c-form-item type="select" label="是否置顶" name="is_top" :options="topState"></c-form-item>
                    <c-form-item type="select" label="是否隐藏" name="is_valid" :options="validState"></c-form-item>
                    <c-form-item type="datetime" label="发布时间" start-name="start_date" end-name="end_date"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button power="b_moments_good_share_edit" color="sys" @click="editClassify()">批量编辑所属模块</c-button>
                <c-button power="b_moments_good_share_edit" color="black" hollow @click="updateValid('batch', 1)">批量显示</c-button>
                <c-button power="b_moments_good_share_edit" color="black" hollow @click="updateValid('batch', 0)">批量隐藏</c-button>
                <c-button power="b_moments_good_share_edit" color="black" hollow @click="updateDelete()">批量删除</c-button>
            </m-operate>

            <c-table ref="table">

                <c-table-column
                        type="selector"
                ></c-table-column>

                <c-table-column
                        label="所属模块"
                        name="classify_name"
                        width="110"
                >
                    <template v-slot="{data}">
                        <span>{{data.classify_name||'--'}}</span>
                    </template>
                </c-table-column>

<!--                <c-table-column
                        label="审核状态"
                        name="state"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state == 1" style="color:dodgerblue">{{stateText[data.state]}}</span>
                        <span v-if="data.state == 2" style="color:darkgreen">{{stateText[data.state]}}</span>
                        <span v-if="data.state == -1" style="color:red">{{stateText[data.state]}}</span>
                    </template>
                </c-table-column>-->

                <c-table-column
                        label="发布用户"
                        name="head_photo"
                        width="200"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="40" style="margin-right: 10px;"></c-image>
                            <div>
                                <span>{{data.nick_name||'--'}}</span></br>
                                <span style="color:blue">{{data.user_manage_mobilephone}}</span>
                            </div>
                        </div>
                    </template>
                </c-table-column>

                <c-table-column
                        label="标题"
                        name="title"
                        width="200"
                ></c-table-column>

                <c-table-column
                        label="浏览量"
                        name="pv"
                        width="80"
                ></c-table-column>

                <c-table-column
                        label="点赞数量"
                        name="thumb_count"
                        width="80"
                ></c-table-column>

                <c-table-column
                        label="收藏数量"
                        name="collect_count"
                        width="80"
                ></c-table-column>

                <c-table-column
                        label="评论数量"
                        name="comment_count"
                        width="80"
                >
                    <template v-slot="row">
                        <span v-if="row.data.comment_count > 0">
                            <a class="s-link" @click="navigateTo(`/moments_comment?comment_id=${row.data.id}`)">
                                &nbsp;{{row.data.comment_count}} &nbsp;
                            </a>
                        </span>
                        <span v-else>0</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="是否推荐"
                        name="is_recommend"
                        width="80"
                >
                    <template v-slot="row">
                        <c-switch :value="row.data.is_recommend == 1" text="是,否" @change="updateRecommend(row, arguments[0], arguments[1])"></c-switch>
                    </template>
                </c-table-column>

                <c-table-column
                        label="是否置顶"
                        name="is_top"
                        width="80"
                >
                    <template v-slot="row">
                        <c-switch :value="row.data.is_top == 1" text="是,否" @change="updateTop(row, arguments[0], arguments[1])"></c-switch>
                    </template>
                </c-table-column>

                <c-table-column
                        label="置顶时间"
                        name="top_date"
                        width="150"
                >
                    <template v-slot="row">
                        <span v-if="row.data.is_top == 1 && row.data.top_date">{{row.data.top_date}}</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="显示隐藏"
                        name="is_valid"
                        width="80"
                >
                    <template v-slot="row">
                        <c-switch :value="row.data.is_valid == 1" text="显示,隐藏" @change="updateValid(row, arguments[0], arguments[1])"></c-switch>
                    </template>
                </c-table-column>
                <c-table-column
                        label="发布时间"
                        name="create_date"
                        width="140"
                >
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="200"
                >
                    <template v-slot="row">
                        <c-table-button power="b_moments_good_share_view" v-if="row.data.comment_count > 0" @click="navigateTo(`/moments_comment?comment_id=${row.data.id}`)">查看评论</c-table-button>
                        <c-table-button power="b_moments_good_share_view" @click="navigateTo(`/moments_good_share_detail/${row.data.id}`)">分享详情</c-table-button>
                        <c-table-button power="b_moments_good_share_edit" @click="updateDelete(row.data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>
        <c-dialog ref="editClassifyDialog" title="设置所属分类" width="450" @resolve="editClassifyHandle">
            <c-form ref="editClassifyForm">
                <c-form-item type="select" label="所属模块" name="classify" required options="CLASSIFY_SHARE"></c-form-item>
            </c-form>
        </c-dialog>
    </page>
</template>

<script>
    export default {
        name: 'moments_good_share',

        data() {
            return {
                state: [ {
                    name: '未审核',
                    value: 1
                }, {
                    name: '已审核',
                    value: 2
                }, {
                    name: '驳回',
                    value: -1
                }],
                recommendState: [{
                    name: '不推荐',
                    value: '0'
                }, {
                    name: '推荐',
                    value: '1'
                }
                ],
                topState: [{
                    name: '不置顶',
                    value: '0'
                }, {
                    name: '已置顶',
                    value: '1'
                }
                ],
                validState: [{
                    name: '隐藏',
                    value: '0'
                }, {
                    name: '显示',
                    value: '1'
                }
                ]
            }
        },

        computed: {
            stateText() {
                var state = {};
                this.state.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
        },

        mounted() {
            this.$refs.search.search();

        },

        methods: {
            searchHandle(data) {
                data.moments_type = 5; // 分享管理
                this.$refs.table.load({
                    url: '/moments/list',
                    data
                });
            },

            updateRecommend(item, state, stop) {
                stop();
                this.$confirm({
                    text: '确定要' + (state ? '推荐' : '取消推荐') +'【' + item.data.title + '】吗？',
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/moments/edit_recommend_state',
                            data: {
                                id: item.data.id,
                                is_recommend: state,
                            },
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
            updateValid(item, state, stop) {
                var list = item == 'batch' ? this.$refs.table.getRow('selected') : [item];
                stop && stop();

                if (!list.length) {
                    this.$message({
                        text: '请选择要操作的内容'
                    });
                    return;
                }

                this.$confirm({
                    text: '确定要' + (state ? '显示' : '隐藏') + (item == 'batch' ? '所选' : '该') +'内容吗？',
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/moments/batch_edit_valid_state',
                            data: {
                                ids: Array.from(list, item => item.data.id),
                                is_valid: state ? 1 : 0
                            },
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
            //批量删除
            updateDelete(item) {
                var list = item ? [{
                    data: item
                }] : this.$refs.table.getRow('selected');
                if (!list.length) {
                    this.$message({
                        text: '请选择要操作的内容'
                    });
                    return;
                }

                this.$confirm({
                    text: '确定要删除'+ (item ? '该' : '所选') +'内容吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/moments/batch_delete',
                            data: {
                                ids: Array.from(list, item => item.data.id),
                                is_delete:1
                            },
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
            //置顶
            updateTop(item, state, stop) {
                stop();
                this.$confirm({
                    text: '确定要'+(state ? '置顶' : '取消置顶')+'【'+item.data.title+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/moments/edit_top_state',
                            data: {id:item.data.id,is_top:state},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
            //批量编辑所属模块
            editClassify() {
                this._auditIds = [];
                //批量操作
                var list = this.$refs.table.getRow('selected');
                if (!list.length) {
                    this.$message({
                        text: '请选择要操作的记录'
                    });
                    return;
                }
                this._auditIds = Array.from(list,item=>{
                    return item.data.id;
                });
                this.$refs.editClassifyDialog.open()
            },
            //批量设置所属模块
            editClassifyHandle(stop){
                stop();
                this.$refs.editClassifyForm.submit({
                    url: '/moments/edit/classify',
                    rule: {
                        classify:[{
                            type:'empty',
                            word: '请选择当前分享归属的模块'
                        }]
                    },
                    dataFormatter: data => {
                        data.moments_ids = this._auditIds ;
                        return data;
                    },
                    success: (data,obj) => {
                        this.$message({
                            text: '操作成功'
                        });
                        this.$refs.table.update();
                        this.$refs.editClassifyDialog.close()
                    }
                })
            },
        }
    }
</script>